import { lazy } from 'react';

export const LazyColumnsBlock = lazy(() =>
  import('./ColumnsBlock').then((m) => ({ default: m.ColumnsBlock }))
);
export const LazyVideoBlock = lazy(() =>
  import('./VideoBlock').then((m) => ({ default: m.VideoBlock }))
);
export const LazyContentSourceBlock = lazy(() =>
  import('./ContentSourceBlock').then((m) => ({ default: m.ContentSourceBlock }))
);
export const LazyEntityCardBlock = lazy(() =>
  import('./EntityCardBlock').then((m) => ({ default: m.EntityCardBlock }))
);
export const LazyEmbedFlowBlock = lazy(() =>
  import('./EmbedFlowBlock').then((m) => ({ default: m.EmbedFlowBlock }))
);
export const LazyIconGridBlock = lazy(() =>
  import('./IconGridBlock').then((m) => ({ default: m.IconGridBlock }))
);
export const LazyStatsRowBlock = lazy(() =>
  import('./StatsRowBlock').then((m) => ({ default: m.StatsRowBlock }))
);
export const LazyAccordionBlock = lazy(() =>
  import('./AccordionBlock').then((m) => ({ default: m.AccordionBlock }))
);
export const LazyTabsBlock = lazy(() =>
  import('./TabsBlock').then((m) => ({ default: m.TabsBlock }))
);
export const LazyTestimonialBlock = lazy(() =>
  import('./TestimonialBlock').then((m) => ({ default: m.TestimonialBlock }))
);
export const LazyCountdownTimerBlock = lazy(() =>
  import('./CountdownTimerBlock').then((m) => ({ default: m.CountdownTimerBlock }))
);
export const LazyPanelGridBlock = lazy(() =>
  import('./PanelGridBlock').then((m) => ({ default: m.PanelGridBlock }))
);
export const LazyImageCarouselBlock = lazy(() =>
  import('./ImageCarouselBlock').then((m) => ({ default: m.ImageCarouselBlock }))
);
export const LazyCalloutBlock = lazy(() =>
  import('./CalloutBlock').then((m) => ({ default: m.CalloutBlock }))
);
